import PlusPencilFeatherSVG from "./plus-pencil-feather.svg?react";
export const PlusPencilFeatherIcon = PlusPencilFeatherSVG;

import PDFBookSVG from "./pdf_book.svg?react";
export const PDFBookIcon = PDFBookSVG;

import AudioBookSVG from "./audio_book.svg?react";
export const AudioBookIcon = AudioBookSVG;

import AudioBookPresetSVG from "./audio_book_preset.svg?react";
export const AudioBookPresetIcon = AudioBookPresetSVG;

import AudioBookDisabledSVG from "./audio_book_disabled.svg?react";
export const AudioBookDisabledIcon = AudioBookDisabledSVG;

import AudioBookCustomSVG from "./audio_book_custom.svg?react";
export const AudioBookCustomIcon = AudioBookCustomSVG;

import GiftBookCustomSVG from "./gift_book.svg?react";
export const GiftBookIcon = GiftBookCustomSVG;
